const STORAGE_KEY = 'planner_ui_state_v1';

const canUseStorage = () => typeof window !== 'undefined' && window.localStorage;

export const loadPlannerUiState = () => {
  try {
    if (!canUseStorage()) {
      return null;
    }
    const serializedValue = window.localStorage.getItem(STORAGE_KEY);
    if (!serializedValue) {
      return null;
    }
    const parsedValue = JSON.parse(serializedValue);
    if (!parsedValue || typeof parsedValue !== 'object' || Array.isArray(parsedValue)) {
      return null;
    }
    return {
      ...parsedValue,
      showReminders: parsedValue.showReminders !== false,
    };
  } catch (error) {
    return null;
  }
};

export const savePlannerUiState = (plannerState) => {
  try {
    if (!canUseStorage()) {
      return;
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(plannerState));
  } catch (error) {
    // ignore storage write errors
  }
};
